module.exports = __webpack_public_path__ + "static/img/sin_logo.5616b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sin_logo.png
// module id = PAed
// module chunks = 1